var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageDucSampleMobile = function SvgImageDucSampleMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 87 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.74 2H10a8 8 0 0 0-8 8v50a8 8 0 0 0 8 8h66.74a8 8 0 0 0 8-8V10a8 8 0 0 0-8-8ZM10 0C4.477 0 0 4.477 0 10v50c0 5.523 4.477 10 10 10h66.74c5.522 0 10-4.477 10-10V10c0-5.523-4.478-10-10-10H10Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.485 43.032a9 9 0 0 0-12.027.8L3.718 65.198a1 1 0 0 1-1.435-1.394l20.74-21.363a11 11 0 0 1 14.7-.98l11.526 9.081 15.194-5.32a11 11 0 0 1 7.316.016l13.576 4.82a1 1 0 1 1-.67 1.885l-13.576-4.82a9 9 0 0 0-5.985-.013L51.09 52.015l19.536 15.706a1 1 0 0 1-1.253 1.558L48.442 52.452l-.008-.006-11.95-9.414ZM67.39 18.165a6.25 6.25 0 1 0-10.716 6.43l.136.217a6.244 6.244 0 0 0 10.706-6.425l-.127-.222Zm-9.916-3.832c3.98-2.577 9.307-1.278 11.653 2.842l.127.222a8.244 8.244 0 0 1-14.135 8.483l-.136-.216a8.25 8.25 0 0 1 2.49-11.33Z",
    fill: "#D6D6D6"
  })));
};
export default SvgImageDucSampleMobile;